import { numberFormatter } from "../../dynamic/numberFormatter";

const printProductSalesReport = async (printData) => {
  const { groupedData, filter, settingData, allUserData, data } = printData;
  const selectedUser = allUserData?.find(user => user.id === filter.createdBy);
  
  const form = document.createElement("form");

  form.innerHTML = `
  <style>
    @media print {
      @page {
        margin: 0;
      }
      body {
        margin: 0;
        padding: 0;
      }
    }
    body {
      font-family: Arial, sans-serif;
      color: black;
    }
    .report {
      width: 95%;
      margin: auto;
      padding: 20px;
   
      box-sizing: border-box;
    }
    .header {
      text-align: center;
      margin-bottom: 15px;
      padding-bottom: 10px;
      border-bottom: 2px solid #000;
    }
    .header h1 {
      margin: 0;
      font-size: 1.5rem;
    }
    .details {
      margin-bottom: 15px;
      font-size: 1rem;
    }
    .detailsFlex {
      display: flex;
      justify-content: space-between;
      margin-bottom: 5px;
    }
    .category-container {
      border: 1px solid #ccc;
      padding: 10px;
      margin-bottom: 15px;
    }
    .category-title {
      font-weight: bold;
      font-size: 1.1rem;
      margin-bottom: 8px;
      border-bottom: 1px solid #ddd;
      padding-bottom: 5px;
    }
    table {
      width: 100%;
      border-collapse: collapse;
      font-size: 0.95rem;
      table-layout: fixed;
    }
    th, td {
      border: 1px solid #aaa;
      padding: 6px 8px;
      text-align: left;
      word-wrap: break-word;
    }
    th {
      background-color: #f5f5f5;
    }
    .category-total {
      font-weight: bold;
      background-color: #eaeaea;
    }
    .summary {
      margin-top: 20px;
      padding-top: 10px;
      border-top: 2px solid #000;
      font-size: 1rem;
    }
    .summary-row {
      display: flex;
      justify-content: space-between;
      margin: 4px 0;
    }
    .summary-row:last-child {
      font-weight: bold;
    }
  </style>

  <div class="report">  
    <header class="header">
      <h1>Sales Report</h1>
    </header>

    <section class="details">
      <div class="detailsFlex">
        <p><strong>From Date:</strong> ${filter.fromDate}</p>
        <p><strong>To Date:</strong> ${filter.toDate}</p>
      </div>
      <div class="detailsFlex">
        <p><strong>User:</strong> ${selectedUser ? selectedUser.name : 'All Users'}</p>
      </div>
    </section>

    ${Object.keys(groupedData).map(category => `
      <div class="category-container">
        <div class="category-title">${category}</div>
        <table>
          <thead>
            <tr>
                <th style="width: 50%;">Item</th>
                <th style="width: 30%;">Type</th>
                <th style="width: 20%;">Qty</th>
            </tr>
            </thead>
          <tbody>
          ${groupedData[category].map((item, index) => `
            <tr key="${index}-info">
                <td style="width: 60%;">${item.product?.name}</td>
                <td style="width: 20%;">${item.transaction?.type}</td>
                <td style="width: 20%;">${numberFormatter(item.quantity, 2)}</td>
            </tr>
            <tr key="${index}-price">
                <td colspan="3" style="text-align: right; font-style: italic;">
                ${numberFormatter(item.totalPrice, 2)}${settingData.currency}
                </td>
            </tr>
            `).join('')}


        <tr class="category-total">
            <td colspan="3" style="text-align: right;">
                Total: ${
                numberFormatter(
                    groupedData[category].reduce((sum, item) => sum + Number(item.totalPrice || 0), 0),
                    2
                )
                }${settingData.currency}
            </td>
            </tr>



          </tbody>
        </table>
      </div>
    `).join('')}

    <section class="summary">
      <div class="summary-row">
        <span>Total Sales:</span>
        <span>${numberFormatter(data?.summary?.totalSales, 2)} ${settingData.currency}</span>
      </div>
      <div class="summary-row">
        <span>Total Discounts:</span>
        <span>${numberFormatter(data?.summary?.totalDiscounts, 2)} ${settingData.currency}</span>
      </div>
      <div class="summary-row">
        <span>Total:</span>
        <span>${numberFormatter((data?.summary?.totalSales || 0) - (data?.summary?.totalDiscounts || 0), 2)} ${settingData.currency}</span>
      </div>
      <div class="summary-row">
        <span>Total Cost:</span>
        <span>${numberFormatter(data?.summary?.totalCost, 2)} ${settingData.currency}</span>
      </div>
      <div class="summary-row">
        <span>Total Profit:</span>
        <span>${numberFormatter(data?.summary?.totalProfit, 2)} ${settingData.currency}</span>
      </div>
    </section>

  </div>
  `;

  const newWindow = window.open("", "_blank", "width=800,height=600");
  newWindow.document.body.appendChild(form);
  await new Promise(resolve => setTimeout(resolve, 10));
  newWindow.print();
  newWindow.close();
};

export {
  printProductSalesReport,
};
